import {
    Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/redpacket';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async list(params: any) {
        return api.list(params);
    }
}
